import { useEffect, useState } from 'react';
import { applyTheme, readThemeMode, setThemeMode, watchSystemTheme, type ThemeMode } from '../theme';

const THEMES: { mode: ThemeMode; label: string; title: string }[] = [
  { mode: 'auto', label: 'Auto', title: "Match this device's appearance setting" },
  { mode: 'light', label: 'Light', title: 'Always light' },
  { mode: 'dark', label: 'Dark', title: 'Always dark' },
];

function ThemePicker() {
  const [mode, setMode] = useState<ThemeMode>(readThemeMode);

  useEffect(() => {
    applyTheme(mode);
    return watchSystemTheme(() => mode);
  }, [mode]);

  return (
    <div className="theme-picker" role="group" aria-label="Appearance">
      {THEMES.map((t) => (
        <button
          key={t.mode}
          className={`theme-btn ${mode === t.mode ? 'active' : ''}`}
          title={t.title}
          onClick={() => {
            setThemeMode(t.mode);
            setMode(t.mode);
          }}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

/**
 * Appearance — the theme picker.
 * Lives at the foot of the sidebar on a computer. On a phone the sidebar
 * shrinks to a row of tabs with no room for it, so Settings renders this same
 * panel instead — one component, so the two can never drift apart.
 *
 * WHO YOU ARE IS NO LONGER HERE. The account button moved to the top bar (see
 * AccountMenu), beside the bell. AND NEITHER IS THE VERSION: it moved up to a
 * chip by the wordmark (see VersionChip), so it is not a scroll to the foot of a
 * long sidebar any more (Vinnie, 26 Sep). The foot is just appearance now.
 */
export default function AccountPanel() {
  return <ThemePicker />;
}
